export default __webpack_public_path__ + "static/media/logo.707ae5e1.png";